import { cn } from "@ui/lib/utils";

import "./FakeProgressBar.css";
import clsx from "clsx";

function FakeProgressBar({
  duration,
  isComplete = false,
  className,
  inverse = false,
}: {
  duration: number;
  isComplete?: boolean;
  className?: string;
  inverse?: boolean;
}) {
  return (
    <div
      className={cn(
        "relative mx-16 h-2 overflow-hidden rounded-full",
        inverse ? "bg-[rgba(255,255,255,0.2)]" : "bg-dark",
        className,
      )}
      style={{ "--progress-duration": `${duration}s` } as React.CSSProperties}
    >
      <div
        className={clsx(
          "fake-progress-bar absolute left-0 top-0 h-full w-full rounded-full",
          isComplete && "is-complete",
          inverse ? "bg-[rgba(255,255,255,1)]" : "bg-inverse",
        )}
      />
    </div>
  );
}

export default FakeProgressBar;
